import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const ZoomInIcon = withSvgIcon(
    <g>
        <path d="M475.7 224.7H275v-200h-50v200H25.7v50H225v200h50v-200h200.7z" />
    </g>
);
